var _ellipse, _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoResults = function SvgNoResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 120 120"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.628,
    cy: 60.199,
    fill: "#D5DBDE",
    rx: 59,
    ry: 59.199
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.846,
    cy: 53.846,
    r: 52.346,
    stroke: "#ABB6BD",
    strokeDasharray: "1 10",
    strokeWidth: 3,
    transform: "scale(.99831 1.00168)rotate(45 49.742 65.282)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.846,
    cy: 53.846,
    r: 49.846,
    stroke: "#ABB6BD",
    strokeDasharray: "1 60",
    strokeWidth: 8,
    transform: "scale(.99831 1.00168)rotate(45 49.742 65.282)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F07D00",
    strokeWidth: 0.5,
    d: "m89.236 29.99 1.416.084.083 1.42 2.032 2.04-.31-5.272-5.252-.31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F07D00",
    d: "m66.846 41-1.128 23.15h-11.59L53 41zM53 79.77V68.137h13.846V79.77z"
  })));
};
export default SvgNoResults;